<div fxLayout="column" *ngIf="isAssessmentComplete" fxLayoutAlign="center center">
  <h2 style="text-align: center;">Below are the results of your self assessment. Please use your results, along with the
    guides to further your spiritual walk.</h2>

  <div class="legend" fxLayout="row" fxLayout.lt-sm="column-reverse" fxLayoutAlign="center center" fxLayoutGap="8px" style="margin: 16px auto; width: 100%;">
    <pxb-list-item-tag label="Exploring Christ" [backgroundColor]="colors.blue[500]" fontColor="white"> </pxb-list-item-tag>
    <mat-icon class="arrow-icon">arrow_right_alt</mat-icon>
    <pxb-list-item-tag label="Growing In Christ" [backgroundColor]="colors.blue[500]" fontColor="white"> </pxb-list-item-tag>
    <mat-icon class="arrow-icon">arrow_right_alt</mat-icon>
    <pxb-list-item-tag label="Close To Christ" [backgroundColor]="colors.blue[500]" fontColor="white"> </pxb-list-item-tag>
    <mat-icon class="arrow-icon">arrow_right_alt</mat-icon>
    <pxb-list-item-tag label="Christ-Centered" [backgroundColor]="colors.blue[500]" fontColor="white"> </pxb-list-item-tag>
  </div>

  <div class="guide-container">
      <pxb-info-list-item divider="full" class="result-item">
        <div pxb-title>Bible Study</div>
        <mat-icon [style.color]="colors.blue[500]" pxb-icon>menu_book</mat-icon>
        <div pxb-subtitle *ngIf="assessment.bibleStudyLevel === 1">Exploring Christ</div>
        <div pxb-subtitle *ngIf="assessment.bibleStudyLevel === 2">Growing In Christ</div>
        <div pxb-subtitle *ngIf="assessment.bibleStudyLevel === 3">Close To Christ</div>
        <div pxb-subtitle *ngIf="assessment.bibleStudyLevel === 4">Christ-Centered</div>
        <p pxb-right-content (click)="navigate('bible-path-guide')" class="guide-link">View Guide</p>
      </pxb-info-list-item>

      <pxb-info-list-item divider="full" class="result-item">
        <div pxb-title>Prayer</div>
        <mat-icon [style.color]="colors.blue[500]" pxb-icon>chat</mat-icon>
        <div pxb-subtitle *ngIf="assessment.prayerLevel === 1">Exploring Christ</div>
        <div pxb-subtitle *ngIf="assessment.prayerLevel === 2">Growing In Christ</div>
        <div pxb-subtitle *ngIf="assessment.prayerLevel === 3">Close To Christ</div>
        <div pxb-subtitle *ngIf="assessment.prayerLevel === 4">Christ-Centered</div>
        <p pxb-right-content (click)="navigate('prayer-path-guide')" class="guide-link">View Guide</p>
      </pxb-info-list-item>

      <pxb-info-list-item divider="full" class="result-item">
        <div pxb-title>Service</div>
        <mat-icon [style.color]="colors.blue[500]" pxb-icon>work</mat-icon>
        <div pxb-subtitle *ngIf="assessment.serviceLevel === 1">Exploring Christ</div>
        <div pxb-subtitle *ngIf="assessment.serviceLevel === 2">Growing In Christ</div>
        <div pxb-subtitle *ngIf="assessment.serviceLevel === 3">Close To Christ</div>
        <div pxb-subtitle *ngIf="assessment.serviceLevel === 4">Christ-Centered</div>
        <p pxb-right-content (click)="navigate('service-path-guide')" class="guide-link">View Guide</p>
      </pxb-info-list-item>

      <pxb-info-list-item divider="full" class="result-item">
        <div pxb-title>Giving</div>
        <mat-icon [style.color]="colors.blue[500]" pxb-icon>attach_money</mat-icon>
        <div pxb-subtitle *ngIf="assessment.givingLevel === 1">Exploring Christ</div>
        <div pxb-subtitle *ngIf="assessment.givingLevel === 2">Growing In Christ</div>
        <div pxb-subtitle *ngIf="assessment.givingLevel === 3">Close To Christ</div>
        <div pxb-subtitle *ngIf="assessment.givingLevel === 4">Christ-Centered</div>
        <p pxb-right-content (click)="navigate('giving-path-guide')" class="guide-link">View Guide</p>
      </pxb-info-list-item>

      <pxb-info-list-item divider="full" class="result-item">
        <div pxb-title>Inviting</div>
        <mat-icon [style.color]="colors.blue[500]" pxb-icon>group</mat-icon>
        <div pxb-subtitle *ngIf="assessment.invitingLevel === 1">Exploring Christ</div>
        <div pxb-subtitle *ngIf="assessment.invitingLevel === 2">Growing In Christ</div>
        <div pxb-subtitle *ngIf="assessment.invitingLevel === 3">Close To Christ</div>
        <div pxb-subtitle *ngIf="assessment.invitingLevel === 4">Christ-Centered</div>
        <p pxb-right-content (click)="navigate('inviting-path-guide')" class="guide-link">View Guide</p>
      </pxb-info-list-item>
  </div>
  <div flex fxLayout="row" fxLayoutAlign="center center" fxLayout.lt-sm="column" fxLayoutGap="16px" style="margin-top: 32px; width: 100%;">
    <button mat-raised-button color="primary" (click)="retakeAssessment()">Re-take Assessment</button>
    <button mat-raised-button color="primary" (click)="navigate('overview')">Discipleship Path Overview</button>
  </div>
</div>

<div fxLayout="column" *ngIf="!isAssessmentComplete" fxLayoutAlign="center center">
  <h3 style="text-align: center;">Oops! Looks like you haven't completed an assessment yet. Click the button below to
    take the assessment.</h3>
  <button mat-raised-button color="primary" (click)="retakeAssessment()">Take Assessment</button>
</div>